import { useWindowDimensions } from "react-native";
import { sessionMaxWidth } from "./constants";

const useNativeItemWidth = (
	sessionType: "formative" | "summative" = "formative",
) => {
	const { width: windowWidth } = useWindowDimensions();
	const isSummativeTest = sessionType === "summative";

	const nativeItemMaxWidth = isSummativeTest
		? sessionMaxWidth.summative
		: sessionMaxWidth.formative;

	return Math.max(1, Math.min(windowWidth, nativeItemMaxWidth));
};

export default useNativeItemWidth;
